export class S3TemplateParams {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetBucketId",
            "baseName": "targetBucketId",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefixTemplate",
            "baseName": "prefixTemplate",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetAccountId",
            "baseName": "targetAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetRegion",
            "baseName": "targetRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "kmsKeyArn",
            "baseName": "kmsKeyArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3TemplateParams.attributeTypeMap;
    }
    constructor() {
    }
}
